import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Home from './Component/Home';
import Navbar from './Component/Navbar';
import Fast_Track_Knee_Replacement_by_dr_garlapati_siva_srikar from './Service/Fast_Track_Knee_Replacement_by_dr_garlapati_siva_srikar';
import './Component/Home.css';
import Therapy_Free_Total_Knee_Replacement_by_dr_garlapti_siva_srikar_guntur from './Service/Therapy_Free_Total_Knee_Replacement_by_dr_garlapti_siva_srikar_guntur';
import Polytrauma_Treatment_by_garlapati_siva_srikar_guntur from './Service/Polytrauma_Treatment_by_garlapati_siva_srikar_guntur';
import Ligament_Repairs_in_Knee_and_Shoulder_Sports_Injuries_by_dr_garlapati_sivasrikar_gutur from './Service/Ligament_Repairs_in_Knee_and_Shoulder_Sports_Injuries_by_dr_garlapati_sivasrikar_gutur';
import Fracture_Management_by_drgarlapati_sivasrikar_guntur from './Service/Fracture_Management_by_drgarlapati_sivasrikar_guntur';
import Spine_Surgery_by_dr_garlapati_sivasrikar_guntur from './Service/Spine_Surgery_by_dr_garlapati_sivasrikar_guntur';
import Contact from './Component/Contact';
import FooterSection from './Component/FooterSection';
import About from './Component/About';
import Unicompartmental_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur from './Service/Unicompartmental_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur';
import Arthroscopy_Key_Hole_Surgery_by_dr_garlapati_sivasrikar_guntur from './Service/Arthroscopy_Key_Hole_Surgery_by_dr_garlapati_sivasrikar_guntur';
import Revision_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur from './Service/Revision_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur';
import TKR_in_Severe_Deformity_and_Bone_Loss_by_dr_garlapati_sivasrikar from './Service/TKR_in_Severe_Deformity_and_Bone_Loss_by_dr_garlapati_sivasrikar';
import Simple_and_Complex_Primary_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur from './Service/Simple_and_Complex_Primary_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur';
import Robotic_Joint_Replacement_by_dr_garlapati_sivasrikar_guntur from './Service/Robotic_Joint_Replacement_by_dr_garlapati_sivasrikar_guntur';
import General_Ortho_by_dr_garlapati_sivasrikar_guntur from './Service/General_Ortho_by_dr_garlapati_sivasrikar_guntur';
import Total_Hip_Replacement_by_dr_garlapati_sivasrikar_guntur from './Service/Total_Hip_Replacement_by_dr_garlapati_sivasrikar_guntur';
import Doctors_Gallery from './Component/Images';





function App() {
  return (
    <>

      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path='/Fast_Track_Knee_Replacement_by_dr_garlapati_siva_srikar' element={<Fast_Track_Knee_Replacement_by_dr_garlapati_siva_srikar />} />
          <Route path='/Therapy_Free_Total_Knee_Replacement_by_dr_garlapti_siva_srikar_guntur' element={<Therapy_Free_Total_Knee_Replacement_by_dr_garlapti_siva_srikar_guntur />} />
          <Route path='/Polytrauma_Treatment_by_garlapati_siva_srikar_guntur' element={<Polytrauma_Treatment_by_garlapati_siva_srikar_guntur />} />
          <Route path='/Ligament_Repairs_in_Knee_and_Shoulder_Sports_Injuries_by_dr_garlapati_sivasrikar_gutur' element={<Ligament_Repairs_in_Knee_and_Shoulder_Sports_Injuries_by_dr_garlapati_sivasrikar_gutur />} />
          <Route path='/Fracture_Management_by_drgarlapati_sivasrikar_guntur' element={<Fracture_Management_by_drgarlapati_sivasrikar_guntur />} />
          <Route path='/Spine_Surgery_by_dr_garlapati_sivasrikar_guntur' element={<Spine_Surgery_by_dr_garlapati_sivasrikar_guntur />} />
          <Route path='/Contact' element={<Contact />} />
          <Route path='/About' element={<About/>}/>
          <Route path='/Unicompartmental_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur' element={<Unicompartmental_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur/>}/>
          <Route path='/Arthroscopy_Key_Hole_Surgery_by_dr_garlapati_sivasrikar_guntur' element={<Arthroscopy_Key_Hole_Surgery_by_dr_garlapati_sivasrikar_guntur/>}/>
          <Route path='/Revision_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur' element={<Revision_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur/>}/>
          <Route path='/TKR_in_Severe_Deformity_and_Bone_Loss_by_dr_garlapati_sivasrikar' element={<TKR_in_Severe_Deformity_and_Bone_Loss_by_dr_garlapati_sivasrikar/>}/>
          <Route path='/Simple_and_Complex_Primary_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur' element={<Simple_and_Complex_Primary_Total_Knee_Replacement_by_dr_garlapati_sivasrikar_guntur/>}/>
          <Route path='/Robotic_Joint_Replacement_by_dr_garlapati_sivasrikar_guntur' element={<Robotic_Joint_Replacement_by_dr_garlapati_sivasrikar_guntur/>}/>
          <Route path='/General_Ortho_by_dr_garlapati_sivasrikar_guntur' element={<General_Ortho_by_dr_garlapati_sivasrikar_guntur/>}/>
          <Route path='/Total_Hip_Replacement_by_dr_garlapati_sivasrikar_guntur' element={<Total_Hip_Replacement_by_dr_garlapati_sivasrikar_guntur/>}/>
          <Route path='/Doctors_Gallery' element={<Doctors_Gallery/>}/>
        </Routes>

        <div className='custom-container service_block'>
          <FooterSection />
        </div>
      </BrowserRouter>

    </>
  );
}

export default App;
